import Vue from 'vue';
import App from './App';
import ErrorPopup from './errorPopup';
import router from './router';
import i18n from './i18n';
import store from './store';
import RnAppMetrica from './mixins/RnAppMetrica';
import sendGAEvent from './mixins/sendGAEvent';
import './global';

Vue.config.productionTip = false;
Vue.use(ErrorPopup);
Vue.mixin(RnAppMetrica);
Vue.mixin(sendGAEvent);

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');

if (store.paymentStatus === 'success') {
  router.push('/success');
}
